<template>
<div style="height:100%">
    <div id="cesiumContainer"></div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widget from "cesium/Widgets/widgets.css";
export default {
    name:'terrain',
    mounted() {
        var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
    },
    methods:{
           init() {
                var viewerOption = {
                    geocoder: true, // 地理位置查询定位控件
                    homeButton: true, // 默认相机位置控件
                    timeline: false, // 时间滚动条控件
                    navigationHelpButton: true, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: true, // 底图切换控件
                    animation: false, // 控制场景动画的播放速度控件
                    shouldAnimate: true,
                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                    }),
                    //加入世界地形图
                    terrainProvider:new Cesium.createWorldTerrain({
                        requestWaterMask:true,
                        requestVertexNormals:true
                    })
                };
                    let viewer = new Cesium.Viewer('cesiumContainer',viewerOption);
                    viewer.scene.globe.depthTestAgainstTerrain = true;
                    viewer.scene.camera.flyTo({
                        destination: Cesium.Cartesian3.fromRadians(-2.6399828792482234, 1.0993550795541742, 5795),
                        orientation: {
                            heading: 3.8455,
                            pitch: -0.4535,
                            roll: 0.0
                        }
                    })
                    viewer.scene.sun.destroy(); //去掉太阳
                    viewer.scene.sun = undefined; //去掉太阳
                    viewer.scene.moon.destroy(); //去掉月亮
                    viewer.scene.moon = undefined; //去掉月亮
                    viewer._cesiumWidget._creditContainer.style.display = "none";// 隐藏版权
            }
    }
}
</script>
<style scoped>
 #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
